import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getSavedInfo = normalize.getSavedInfo(function (options) {
  var filePath = options.filePath,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  ks.getFileInfo({
    filePath: filePath,
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.KWAI);
export default getSavedInfo;